import axios from "axios";
import config from "../config.json";

// 공통 axios 인스턴스 생성 (헤더 공통 설정)
const apiClient = axios.create({
  baseURL: config.API_URL,
  headers: {
    "Content-Type": "application/json",
    "x-api-key": config.API_KEY,
  },
});

export const getGDFPrice = async () => {
  try {
    const url = "/admin/token/price";
    console.log("url:", url);

    // Axios 요청
    const response = await apiClient.get(url);

    // 응답 데이터
    const data = response.data;

    // 데이터 상태 확인
    if (data.status === "success") {
      return data.result;
    } else {
      throw new Error(data.message || "가격 조회 실패");
    }
  } catch (error) {
    console.error("가격 조회 중 오류:", error);
    throw error;
  }
};

export const handleRequest = async (url, data) => {
  try {
    const response = await apiClient.post(url, data);
    return response.data;
  } catch (error) {
    console.error("API 요청 중 오류:", error);
    alert("요청 처리 중 오류가 발생했습니다.");
    throw error;
  }
};
